import { render, staticRenderFns } from "./ServiceGlance.vue?vue&type=template&id=1b65ce4a&"
import script from "./ServiceGlance.vue?vue&type=script&lang=js&"
export * from "./ServiceGlance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports